import styled from 'styled-components';

export const ValueInput = styled.div`
  margin-top: 31px;
`;
